import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si ya tengo formación en Constelaciones?',
    a: 'Especialmente si ya tenés formación. Este Vademécum no te enseña a constelar. Te da el sistema para hacerlo con más orden, más profundidad y más registro. Terapeutas con años de práctica reportan que es lo que les faltaba para llevar sus procesos al siguiente nivel.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago recibís un correo de soportelumenakasha@gmail.com con el enlace de descarga. Acceso en menos de 5 minutos.'
  }, {
    q: '¿Necesito imprimirlo todo?',
    a: 'No. Podés usarlo en tablet con lápiz digital, en computadora o impreso. El libro y los bonos están diseñados para funcionar en ambos formatos. Las planillas son especialmente cómodas en tablet.'
  }, {
    q: '¿Qué lo diferencia de recursos que puedo buscar gratis?',
    a: 'El trabajo libre online no está integrado, no está adaptado a la práctica de constelaciones familiares y no tiene el nivel de detalle clínico de este sistema. Este Vademécum es un sistema que funciona como un todo, no una colección de recursos sueltos.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía completa. Si no es lo que esperabas, escribís a soportelumenakasha@gmail.com y te devolvemos el 100% del valor sin preguntas ni formularios.'
  }, {
    q: '¿Puedo compartirlo con otros terapeutas?',
    a: 'No. El Vademécum es de uso personal e intransferible. Compartirlo es una violación de los derechos de autor y perjudica el trabajo que hay detrás de este material.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-68" data-mp="n0hp0zqtd2pc">
      <div className="text-center mb-12" data-id="element-69" data-mp="mzgfizpg4o9q">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-violetDark" data-id="element-70" data-mp="2pmn3nt8u7pyk">
          <span className="mr-3" data-id="element-71" data-mp="2kuvn8bjeb0m5">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-72" data-mp="2fw28kfsdh3ke">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-gold/25 bg-white/80" data-id="element-73" data-mp="2axqyq522ut26" data-mpi={i}>
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-74" data-mp="38kg3uns2tls9">
              <span className="font-medium pr-8 text-brand-violetDark text-[14px]" data-id="element-75" data-mp="2um01f918yhfx">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-76" data-mp="1n97pnnb7ec91" />
            </button>
            <AnimatePresence data-id="element-77" data-mp="3uuxzqh96upq8">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-78" data-mp="2pufznwaslry">
                  <div className="px-6 pb-5 text-brand-text/80 border-t border-brand-gold/20 pt-4 bg-white/60 text-[13px] leading-relaxed" data-id="element-79" data-mp="mfxvfiwl4vyp">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};